import { render, staticRenderFns } from "./TextDisplay.vue?vue&type=template&id=aaace0dc&scoped=true"
import script from "./TextDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextDisplay.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaace0dc",
  null
  
)

export default component.exports